import React, { PropTypes, PureComponent } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { authAccount } from '../../store/account/actions';
import { register as registerDevice } from '../../store/device/actions';
import { remove as removeNotification, clear as clearNotifications }
  from '../../store/messages/notifications/actions';

import { SetupHeader } from './SetupHeader';
import { Authenticate } from './authenticate';
import { Register } from './register';
import { Confirm } from './confirm';

import { RightToLeft, Fade } from '../transitions';
import { Messagebar } from '../shared/messagebar/main';
import { bg } from '../../store/index';

import './styles.scss';

export class SetupComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.next = this.next.bind(this);

    let activities = []; // list of activities for state

    const [token, id] = [this.props.account.accessToken, this.props.device.deviceId];
    if (!token && !id) {
      activities = ['authenticate', 'register', 'confirm'];
    } else if (!token) {
      activities = ['authenticate', 'confirm'];
    } else if (!id) {
      activities = ['register', 'confirm'];
    } else {
      activities = ['confirm'];
    }

    this.state = { activities };
  }

  next() {
    // this should not exist.  the activities should be determined
    // based on the props coming in from the top
    const [currActivity, ...newActivities] = this.state.activities;
    if (currActivity === 'authenticate') {
      bg.refreshNow();
    }

    this.setState({ activities: newActivities });
  }

  removeNotifications() {
    if (this.props.notifications.length > 0) {
      this.props.clearNotifications();
    }
  }

  renderActivity() {
    const { props, state, next } = this;

    switch (state.activities[0]) {
      case 'register':
        return <Register {...props} next={next} key={3} />;
      case 'confirm':
        return <Confirm {...props} next={next} key={5} />;
      case 'authenticate':
      default:
        return <Authenticate {...props} next={next} key={1} />;
    }
  }

  renderNotification() {
    if (this.props.notifications.length > 0) {
      const notification = this.props.notifications[0];
      return (<Messagebar
        index={0} // in the future, this should be the actual message index
        remove={this.props.removeNotification}
        {...notification}
      />);
    }

    return null;
  }

  render() {
    return (
      <div className='setup' onClick={() => this.removeNotifications()}>
        <div className='headerBar'>
          {this.state.activities[0] === 'welcome' ? null : <SetupHeader />}
          <Fade>{this.renderNotification()}</Fade>
        </div>
        <RightToLeft className='transitionContainer'>
          {this.renderActivity()}
        </RightToLeft>
      </div>
    );
  }
}

SetupComponent.propTypes = {
  clearNotifications: PropTypes.func,
  notifications: PropTypes.array,
  device: PropTypes.object,
  setup: PropTypes.object,
  account: PropTypes.object,
};

function mapToState(state) {
  return {
    notifications: state.getIn(['messages', 'notifications']).toJS(),
    device: state.get('device').toJS(),
    account: state.get('account').toJS(),
  };
}

export const Setup = connect(mapToState, {
  authAccount,
  registerDevice,
  removeNotification,
  clearNotifications,
})(injectIntl(SetupComponent));



// WEBPACK FOOTER //
// ./src/components/setup/main.jsx